import React from "react";
import { Tag } from "primereact/tag";
import { TariffType } from "../../types";

export interface CommunityPriceCardHeaderProps {
  tariffId: string;
  activeTill?: string | null;
  tariffType?: TariffType;
  className?: string;
}

const TARIFF_TYPE_LABEL: Record<string, string> = {
  REGULAR: "STATIC",
  DAY_NIGHT: "DAY-NIGHT",
  HOURLY: "HOURLY",
};

type TagSeverity = React.ComponentProps<typeof Tag>["severity"];

const TARIFF_TYPE_SEVERITY: Record<string, TagSeverity> = {
  REGULAR: undefined,
  DAY_NIGHT: "warning",
  HOURLY: "info",
};

export const CommunityPriceCardHeader: React.FC<CommunityPriceCardHeaderProps> = React.memo(
  ({ tariffId, activeTill, tariffType, className }) => {
    const isActive = !activeTill;
    const tariffLabel = tariffType ? (TARIFF_TYPE_LABEL[tariffType] ?? tariffType) : null;
    const tariffSeverity: TagSeverity = tariffType ? (TARIFF_TYPE_SEVERITY[tariffType] ?? "info") : "info";
    return (
      <div className={`flex items-center justify-content-between p-3 pb-0 ${className ?? ""}`}>
        <div className="font-semibold text-lg">Tariff: {tariffId}</div>
        <div className="flex gap-2 align-items-center">
          {tariffLabel && <Tag value={tariffLabel} severity={tariffSeverity} style={{ color: "#fff" }} />}
          <Tag
            value={isActive ? "Active" : "Ended"}
            severity={isActive ? "success" : undefined}
            style={{ color: "#fff", ...(isActive ? {} : { background: "#9ca3af" }) }}
          />
        </div>
      </div>
    );
  }
);
